/**
 * Created by Lorenz.Padberg@iterativ.ch on 09.05.17.
 * Copyright (c) 2017 Iterativ GmbH. All rights reserved
 */


import {of as observableOf } from 'rxjs';

import {pairwise, switchMap, catchError, tap,  map, withLatestFrom, filter } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState,  isNotificationsShown, getNotifications, getAppOnline } from "../reducers";
import { GetNotifications,
        GetNotificationsSuccess,
        NotificationsActionTypes,
        GetNotificationsFail,
        SetLatestNotificationAction,
        SetToLatestNotificationId,
        MarkNotificationsSuccess,
        MarkNotificationsFail,
        GetNotificationsForPage,
        GetNotificationsForPageSuccess,
        GetNotificationsForPageFail,
        MarkAllNotificationsAsReadSuccess,
        MarkAllNotificationsAsReadFail,
        SetNotificationErrorAction,
        UnsetNewNotifications,
        GetNotificationsOfflineForPage
     } from './notifications.actions';
import {UiActionTypes} from '../actions/ui';
import * as auth from '../actions/authentication';
import * as notifications from './notifications.actions';
import { HelloClassApiService } from '../services/helloclass';
import { NotificationsIntervalService } from './notifications-interval.service';
import { NUM_NOTIFICATIONS } from './notifications.const';


@Injectable()
export class NotificationsEffects {

    constructor(private actions$: Actions,
                private store: Store<AppState>,
                private helloclassApi: HelloClassApiService,
                private notificationInterval: NotificationsIntervalService) {
    }

     getNotifications$ = createEffect(() => this.actions$.pipe(
        // .switchMap(() => this.store.select(getAuthUser).filter((userData: UserData) => userData.id > -1).take(1))
        ofType<notifications.GetNotifications>(NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS),
        switchMap((action) => this.helloclassApi.getNotifications(action.payload)),
            map(data => new GetNotificationsSuccess(data)),
            catchError(error => observableOf(new GetNotificationsFail(error))),))

      toggleNotifcations$ = createEffect(() => this.actions$.pipe(
        ofType(UiActionTypes.UI_TOGGLE_NOTIFICATIONS),
        withLatestFrom(this.store.select(isNotificationsShown)),
        filter(data => data[1]),
        map((data) => {
            return new SetToLatestNotificationId();
        })
    ));

     setToLatestNotificationId$ = createEffect(() => this.actions$.pipe(
        ofType(NotificationsActionTypes.NOTIFICATIONS_SET_TO_LATEST_ID),
        withLatestFrom(
            this.store.select(getNotifications),
            this.store.select(getAppOnline)
        ),
        filter(data => data[2]),
        map((data) => {
            const latestId = data[1].length > 0 ? data[1][0].id : -1;
            return new SetLatestNotificationAction(latestId);
        })
    ))

     startInterval$ = createEffect(() => this.actions$.pipe(
        ofType(NotificationsActionTypes.NOTIFICATIONS_START_INTVERVAL),
        map(() => {
            this.notificationInterval.startInterval();
            return { type: "NOP", payload: null };
        })
    ));


     stopInterval$ = createEffect(() => this.actions$.pipe(
        ofType(NotificationsActionTypes.NOTIFICATIONS_CLEAR_INTVERVAL),
        map(() => {
            this.notificationInterval.stopInterval();
            return { type: "NOP", payload: null };
        })
    ))

     markNotification$ = createEffect(() => this.actions$.pipe(
        ofType<notifications.MarkNotifications>(NotificationsActionTypes.NOTIFICATIONS_MARK_NOTIFICATIONS),
        switchMap((action) => this.helloclassApi.markNotification(action.payload)),
            map(data => new MarkNotificationsSuccess()),
            catchError(error => observableOf(new MarkNotificationsFail(error))),));

     getNotificationsForPage$ = createEffect(() => this.actions$.pipe(
        ofType<notifications.GetNotificationsForPage>(NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS_FOR_PAGE),
        withLatestFrom(this.store.select(getAppOnline)),
            filter(data => data[1])
        ).pipe(
        switchMap(() => this.helloclassApi.getNotifications(50)),
            map(data => new GetNotificationsForPageSuccess(data)),
            catchError(error => observableOf(new GetNotificationsForPageFail(error))
    ),));

     markAllNotificationsAsRead$ = createEffect(() => this.actions$.pipe(
        ofType(NotificationsActionTypes.NOTIFICATIONS_MARK_All_NOTIFICATIONS),
        switchMap((action) => this.helloclassApi.markAllNotifications()),
            map(data => new MarkAllNotificationsAsReadSuccess()),
            catchError(error => observableOf(new MarkAllNotificationsAsReadFail(error))),));


     markAllNotificationsAsReadSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(NotificationsActionTypes.NOTIFICATIONS_MARK_All_NOTIFICATIONS_SUCCESS),
        tap(() => this.store.dispatch(new GetNotificationsForPage())))
        .pipe(
            map(() => new GetNotifications(NUM_NOTIFICATIONS))
        ))

     getNotificationFail$ = createEffect(() => this.actions$.pipe(
        ofType(NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS_FAIL,
            NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS_FOR_PAGE_FAIL),
        map((error) => {
            let key = 'Die Meldungen konnten nicht geladen werden.';
            return new SetNotificationErrorAction(key);
        })
    ))

    // handle auth actions
     userDataSuccess$ = createEffect(() => this.actions$.pipe(
        ofType<any>(auth.AuthActionTypes.AUTH_USER_DATA_SUCCESS),
        map(action => action.payload),
            map(userData => {
                return new SetLatestNotificationAction(userData.notificationId);
            })
        ))

     updateSettings = createEffect(() => this.actions$.pipe(
        ofType<any>(NotificationsActionTypes.NOTIFICATIONS_SET_LATEST_ID),
        pairwise(),
        filter(ids => ids[0].payload !== ids[1].payload),
        tap(() => this.store.dispatch(new UnsetNewNotifications())),
        map((ids) => {
                // select the higher id
                let higherId = ids[0].payload;
                if (ids[1].payload > ids[0].payload) {
                    higherId = ids[1].payload;
                }
                return new auth.UpdateLatestNotificationSettings(higherId);
        }),))

    // handle offline actions

     getNotificationsForPageOffline$ = createEffect(() => this.actions$.pipe(
        ofType<notifications.GetNotificationsForPage>(NotificationsActionTypes.NOTIFICATIONS_GET_NOTIFICATIONS_FOR_PAGE),
        withLatestFrom(this.store.select(getAppOnline)),
            filter(data => !data[1]),
            map(() => new GetNotificationsOfflineForPage())
        ));
}
